/* eslint-disable @typescript-eslint/no-unused-vars */
import { TimePeriodOptions } from '../../../../../../redux/context/customReports/types'
import {
  CustomReportCategoryType,
  CustomReportCategory
} from '../../../../../../redux/context/customReports/typesCategory'
import { ReportDataType } from '../../../../../../redux/context/reports/types'
import { VisitorContext, BuilderNode } from './types'

// Define default values for each node type
export const NODE_DEFAULTS: {
  [key in CustomReportCategoryType]: Partial<CustomReportCategory>
} = {
  root: {},
  periodGroup: {
    value: TimePeriodOptions.CurrentMonth,
    dataType: ReportDataType.actuals,
    budgetingScenarioId: null
  },
  company: {},
  dimension: {
    value: undefined
  },
  function: {
    children: []
  },
  reference: {},
  keyFigureId: {},
  formulaId: {}
}

// Create node factory based on node type
export function createBuilderNode(id: string, type: CustomReportCategoryType, context: VisitorContext): BuilderNode {
  // Create base node
  const baseNode: BuilderNode = {
    id,
    type,
    expanded: true,
    isDragging: false,
    children: []
  }

  // Get type-specific defaults and merge with base node
  const typeDefaults = NODE_DEFAULTS[type] || {}
  return {
    ...baseNode,
    ...typeDefaults
  } as BuilderNode
}

export const generateRandomId = () => crypto.randomUUID().substring(0, 8)
